import {__VOYAGER__} from './api-config';

// ---------------- CONSTANTS ---------------- //
export const defaultFlavour = 'v3';
export const defaultCurrency = 'INR';
export const defaultRoomString = '1-2-0'; // duplicate remove one.
export const DEFAULT_PAX_STRING = '1-2-0';
export const defaultSorting = 'popularity';
export const defaultLengthOfStay = 1;
export const olderRoomStringRegex = '/(d)-(d)_(d)/';
export const defaultPartner = 'hotels';
export const defaultVertical = 'hotels';
export const defaultCityVoyagerObjType = 'city';
export const srpIndexForFetchMore = 2;
export const rupeeString = '₹';
export const maxAllowedRoomNights = 20;
export const searchWidgetId = 'search-widget';
export const srpNavigationHeaderOpenCloseThreshold = 75;
export const srpNavigationHeaderOpenCloseOffset = srpNavigationHeaderOpenCloseThreshold + 2;
export const metaCookieName = 'fe_trfc_seg';
export const defaultCheckinTime = '12: 00';
export const defaultNoOfRoomsToShowOnMeb = 2;
export const typesOfSrpLocations = ['city', 'landmark', 'area', 'airport'];

export const defaultCheckinOffset = 7;
export const defaultCheckoutOffset = 8;

export const googleMapsApiKey = 'AIzaSyD9iq-4g7CePAx8L_w3biSfZCdtPTZh0kE'; // goibibo key
export const googleMapsBaseURL = 'https://maps.googleapis.com';
export const staticMapAPIRoute = '/maps/api/staticmap';

export const descblockNewHotelsId = 'newhotels';
export const paymentApiFailureDefaultMessage = 'Something went wrong!';

export const descblockApiFailureDefaultMessage =
  'Selected Room is not available. Please try some other option.';
export const reviewPagePricingAddOnListEarlyCheckInID = 'htl-addon_pah';
export const reviewPagePricingAppliedOfferID = 'htl-promo-disc';
export const reviewPagePricingSavingsID = 'htl-savings';
export const reviewPageGocashId = 'htl-gc';
export const reviewPageGocashPlusId = 'htl-gcp';
export const reviewPageDonateCharityId = 'htl-charity';
export const reviewPageFBTotalId = 'htl-total';
export const isPahReviewPageButtonText = 'Reserve Now Pay Later';
export const isPahCCReviewPageButtonText = 'Reserve Now';
export const goSafeDefaultLogo = 'https://gos3.ibcdn.com/hotelgosafeshield-1588682786.png';
export const segmentSliderSlot = 3;
export const signUpBannerSlot = 5;
export const smartEngageBannerSlot = 7;
export const defaultSeoSrpNoOfHotels = 10;
export const sortingKeyLabelMap = {
  popularity: 'Trending Hotels',
  priceup: 'Price (Low to High)',
  pricedown: 'Price (High to Low)',
  rating: 'Customer Ratings',
};

export const sortingKeyLabelMapForMweb = [
  {name: 'Most Popular', value: 'popularity'},
  {name: 'Cheapest First', value: 'priceup'},
  {name: 'Costliest First', value: 'pricedown'},
  {name: 'User Ratings', value: 'rating'},
];

// kept grouped because india should get changed for both, if changed
export const countryTextMap = {
  india: {key: 'IN', value: 'India', sec: 'domestic', category: 'hotels-domestic'},
  international: {
    key: 'intl',
    value: 'International',
    sec: 'international',
    category: 'hotels-international',
  },
};

// no default country should be there
export const defaultCountry = '';

export const amenitiesMapForSimilarHotels = {
  bc: 'Room Service',
  gym: 'Gym/Spa',
  int: 'Internet Access',
  rest: 'Restaurant',
  sp: 'Swimming Pool',
  freeint: 'Free Internet',
  ac: 'ac active',
  chk: 'chk active',
};

// ! must move this to api-config file
// ------------------ URLS and URL MAKERS --------------- //

export const BASE_VOYAGER_SEARCH_URL = `${__VOYAGER__}/api/v1/hotels_search/find_node_by_name/`;

// ! must move following funcs to either locale of component or some util associated with comp
export const searchWidgetLocationSearchURL = (search_query: string, partner: string) => {
  const params = {
    search_query,
    limit: 10,
    qt: 'N',
    inc_ggl_res: true,
  };

  if (partner === 'gostays') {
    params.hlt = 'gostays';
  }

  const paramsStringified = JSON.stringify(params);

  return `${BASE_VOYAGER_SEARCH_URL}?params=${paramsStringified}`;
};

export const locationAndHotelSearchURL = ({
  inputValue,
  limit = 10,
  cityId,
}: {
  inputValue: string;
  limit?: number;
  cityId: number;
}) => {
  const params = JSON.stringify({
    search_query: inputValue,
    city_filter_id: cityId,
    limit,
    qt: 'D',
    inc_ggl_res: true,
    include_t: ['voy.area', 'voy.landmark', 'ggl.area', 'ggl.landmark', 'voy.hotel'],
  });
  return `${BASE_VOYAGER_SEARCH_URL}?&params=${params}`;
};

export const detailsNavigationElementId = 'details-navigation';

/**
 *  SCROLL INTO VIEW OPTIONS
 *  (for the usage of node module 'smooth-scroll-into-view-if-needed')
 *
 *  this is the config we use on details page. Others might want to use
 *  their own config on any other page.
 *
 */

export const scrollIntoViewOptionsDetails = {
  behavior: 'smooth',
  duration: 1000,
  block: 'start',
  inline: 'start',
};

export const payModes = {
  payNow: 1,
  bnpl: 8,
};

export const bnplStringReplaceMap = {
  DueAmount: '%%due_amount%%',
  Amount: '%%amount%%',
};
export const hermesOfferApiConfig = {
  version: 'v11.5',
};
/**
 * If there's a hash on details page, that means
 * we intend to be scrolled down to a particular element.
 * In order to make the user see that they are being scrolled down
 * we wait for this amount of timeout before scrolling. If we do not
 * do this, then the scroll happens in a flash (without the user being
 * able to see where the scrolling started from)
 */
export const onLoadScrollToElementTimeoutDetails = 750;

export const hotelDetailsGalleryConfig = {
  galleryPageSize: 10,
  elementHeight: 300,
  infiniteLoadBeginEdgeOffset: 400,
};
export const segmentSliderDefaultHctxValue = 'dh_gosafe';

export const persuasionsTemplateIds = {
  goSafe: 1,
  specialDeal: 2,
};

export const srpAPIconfig = {
  desktop: {
    flavour: 'v3',
    version: 'v12',
  },
  mobile: {
    version: 'v11.5',
    flavour: 'mobile',
  },
};
